document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('fade_contents')) return;

  // スタイルをheadに追加
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    .fade_contents img {
      opacity: 0;
      transition: all 0.3s ease-out;
    }
    .fade_contents img.visible {
      opacity: 1;
    }
  `;
  document.head.appendChild(styleElement);

  const handleImageLoad = (img) => {
    if (img.complete) {
      requestAnimationFrame(() => {
        img.classList.add('visible');
      });
    } else {
      img.onload = () => {
        requestAnimationFrame(() => {
          img.classList.add('visible');
        });
      };
      img.onerror = () => {
        requestAnimationFrame(() => {
          img.classList.add('visible');
        });
      };
    }
  };

  // 既存の画像を処理
  Array.from(document.getElementsByTagName('img')).forEach(handleImageLoad);

  // 動的に追加される画像を監視
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeName === 'IMG') {
          handleImageLoad(node);
        } else if (node.getElementsByTagName) {
          Array.from(node.getElementsByTagName('img')).forEach(handleImageLoad);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
